<template>
    <div class="documentation flex items-start w-full" v-if="isMounted">
        <div class="w-full" v-if="newVersion">
            <div class="documentation__card mb-4 mt-4 mr-4">
                <vs-row>
                    <vs-col
                        vs-w="12"
                        vs-sm="6"
                        vs-lg="3"
                        vs-xs="12"
                    >
                        <div class="m-2">
                            <label class="text-sm opacity-75">{{$t('modals.Choose_affiliate')}}</label>
                            <v-select
                                class="w-full popup__select"
                                :reduce="a => a.hash"
                                label="name"
                                :clearable="false"
                                v-model="parametersData.selected.affiliate"
                                :options="parametersData.options.affiliates"
                                @input="selectAffiliate"
                            />
                        </div>
                    </vs-col>
                </vs-row>
            </div>

            <NavBar :nav-items="nav" />
            <router-view :jsonData="json" :selected-data="{...parametersData.selected, token}"></router-view>
        </div>
        <div class="w-full" v-else>
            <div ref="test" class="swaggers" id="swagger"></div>
        </div>
    </div>
</template>

<script>
import vSelect from "vue-select"
import send from "@/utils/fetch"
import ErrorHandler from "@/utils/errorHandler"
import NavBar from './components/navbar/Navbar'
import Main from './view/Main'
import {mixins} from './mixins'

export default {
    mixins: [mixins],
    data() {
        return {
            isMounted: false,
            nav: [],
            hash: '',
            jsonData: {},
            json: {},
            newVersion: true,
            parametersData: {
                options: {
                    teams: [],
                    affiliates: []
                },
                selected: {
                    team: null,
                    affiliate: null,
                    token: null,
                    teamName: null
                }
            }
        }
    },

    components: {
        vSelect,
        NavBar,
        Main
    },

    watch: {
        '$route.params'() {
            this.sendDataToComponent()
        }
    },

    computed: {
        token() {
            return this.$route.params.hash
        }
    },

    methods: {
        _createPath(name) {
            const arr = name.split('/')
            return arr[arr.length -1]
        },

        sortData(a, b) {
            return a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1
        },

        selectAffiliate(hash) {
            this.parametersData.selected.affiliate = null
            this.parametersData.selected.affName = null

            if (hash) {
                const aff = this.parametersData.options.affiliates.find(item => item.hash === hash)
                if (aff) {
                    this.parametersData.selected.affName = aff.name
                    this.parametersData.selected.affiliate = hash
                }
            }
        },

        isNewVersion() {
            const path = this.$route.path.split('/').filter(item => item).join('/')
            if (path) {
                return  path !== `api/${this.hash}`
            }
        },

        createNavMenu() {
            try {
                const navigationArray = []
                Object.keys(this.jsonData.paths).map(path => {
                    Object.keys(this.jsonData.paths[path]).map(method => {
                        navigationArray.push({
                            method,
                            url: `/api/${this.hash}/${this._createPath(path)}/${method}`,
                            name: this.jsonData.paths[path][method].info.title
                        })
                    })
                })
                this.nav = navigationArray
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        sendDataToComponent() {
            try {
                const params = this.$route.params
                if (params.api && params.method) {
                    Object.keys(this.jsonData.paths).map(key => {
                        if (new RegExp(params.api).test(key)) {
                            this.json = {[key]: {[params.method]: this.jsonData.paths[key][params.method]}}
                        }
                    })
                }
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        async isAuth() {
            try {
                const params = {
                    "X-Secret-Key": this.hash
                }
                return await send(this.$url.checkAuth['check-secret-key'], 'POST', {params}, false).then(response => response.data.success)
            } catch (e) {
                location.href = 'https://www.google.com/'
            }
        },

        async getTeamsAndAffiliates() {
            try {
                this.parametersData.options.affiliates = await send(this.$url.team["team-with-users"], 'GET', {params: {
                        secret_key: this.$route.params.hash
                    }}, false)
                    .then(response => response.data.result.users)
                    .then(response => response.sort(this.sortData))

                this.parametersData.selected.affiliate = this.parametersData.options.affiliates[0] ? this.parametersData.options.affiliates[0].hash : null
            } catch (e) {
                new ErrorHandler(e).send
            }
        },
    },

    async mounted() {
        try {
            this.hash = this.$route.params.hash
            this.newVersion = this.isNewVersion()
            const isAuth = await this.isAuth()

            if (isAuth) {
                await this.getTeamsAndAffiliates()

                this.jsonData = await import('./_api.json')

                if (this._isEmptyObject(this.jsonData)) {
                    this.createNavMenu()
                    this.sendDataToComponent()
                }

                this.isMounted = true
            }
        } catch (e) {
            new ErrorHandler(e).send
        }
    }
}
</script>

<style lang="scss">
.documentation {
    &__card {
        background: white;
        border-radius: 10px;
        padding: 20px;
    }

    .router-link-exact-active {
        background-color: rgba(var(--vs-primary), 1);
        color: white;
        border-radius: 4px;
        span {
            color: white !important;
        }
    }

    &__card {
        margin-left: 250px;
    }
}
</style>
